import momentUnLocalized, { MomentInput } from "moment";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DELIVERY_PREP_DAYS_BUFFER } from "../../constant/common.constant";

export const useMoment = () => {
  const { i18n } = useTranslation();

  const moment = useCallback(
    (inp?: MomentInput) => {
      const momentLocale = momentUnLocalized(inp);
      momentLocale.locale(i18n.language);
      return momentLocale;
    },
    [i18n.language]
  );

  const formatShortDate = (inp?: MomentInput) => {
    return moment(inp)
      .locale(i18n.language)
      .format(i18n.language === "fr" ? "D MMM, YYYY" : "MMM D, YYYY");
  };

  const formatFullDate = useCallback(
    (inp?: MomentInput) => {
      return moment(inp)
        .locale(i18n.language)
        .format(i18n.language === "fr" ? "D MMMM YYYY" : "MMMM D, YYYY");
    },
    [i18n.language, moment]
  );

  const formatFullDateWithTime = useCallback(
    (inp?: MomentInput) => {
      return moment(inp)
        .locale(i18n.language)
        .format(
          i18n.language === "fr"
            ? "dddd D MMM YYYY, h:mm A"
            : "dddd, MMM D, YYYY, h:mm A"
        );
    },
    [i18n.language, moment]
  );

  const formatDateTime = (inp?: MomentInput) => {
    return moment(inp)
      .locale(i18n.language)
      .format(
        i18n.language === "fr" ? "D MMMM YYYY, HH:mm" : "MMMM D, YYYY, HH:mm"
      );
  };

  const weeksFromDate = useCallback(
    (weeks?: number, orderDate?: Date) => {
      if (orderDate == null || weeks == null) return "";
      const weeksFromDate = new Date(orderDate);
      weeksFromDate.setDate(
        weeksFromDate.getDate() + 7 * weeks + DELIVERY_PREP_DAYS_BUFFER
      ); //DELIVERY_PREP_DAYS_BUFFER represents the required time to approved the order and get the deposit
      return formatFullDate(weeksFromDate);
    },
    [formatFullDate]
  );

  const weeksFromNow = useCallback(
    (weeks: number) => {
      return weeksFromDate(weeks, new Date());
    },
    [weeksFromDate]
  );

  return {
    moment,
    formatShortDate,
    formatFullDate,
    formatFullDateWithTime,
    formatDateTime,
    weeksFromDate,
    weeksFromNow,
  };
};
